const getExcludeValue = ({ exclude }) => {
  if (!!exclude && exclude === "true") {
    return true;
  }
  if (!!exclude && exclude === "false") {
    return false;
  }
  if (!exclude) {
    return false;
  }
  return true;
};

const mapFilterRules = rules =>
  rules.map(filterRule => ({
    ...filterRule,
    exclude: getExcludeValue(filterRule)
  }));

export const filterRules = ({ $store }) =>
  mapFilterRules($store.state.filterRules.filterRules);

export default { filterRules };
